import { render } from "./PurchaseOrderDetail.vue?vue&type=template&id=5984b5f8"
import script from "./PurchaseOrderDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderDetail.vue?vue&type=script&lang=js"

import "./PurchaseOrderDetail.vue?vue&type=style&index=0&id=5984b5f8&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__